import { useQuery } from "@tanstack/react-query";
import type { SessionUser } from "@breeze/shared";

type MeResponse = { user: SessionUser } | { error: string };

export type SessionState =
  | { status: "loading" }
  | { status: "authenticated"; user: SessionUser }
  | { status: "anonymous" };

async function fetchMe(): Promise<SessionState> {
  const res = await fetch("/api/auth/me", { credentials: "include" });
  if (res.status === 401) return { status: "anonymous" };
  if (!res.ok) throw new Error(`auth/me ${res.status}`);
  const body = (await res.json()) as MeResponse;
  if ("user" in body) return { status: "authenticated", user: body.user };
  return { status: "anonymous" };
}

export function useSession(): SessionState {
  const q = useQuery({
    queryKey: ["session"],
    queryFn: fetchMe,
    retry: false,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: true,
  });
  if (q.isLoading && !q.data) return { status: "loading" };
  return q.data ?? { status: "anonymous" };
}

export async function logout(): Promise<void> {
  await fetch("/api/auth/logout", {
    method: "POST",
    credentials: "include",
  });
  window.location.href = "/";
}
